// frontend/src/app/about/page.tsx
'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

export default function AboutPage() {
  const t = useTranslations('about');

  return (
    <main className="max-w-2xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-[#1a2e1f] mb-2">{t('title')}</h1>
      <p className="text-[#6b8c7a] mb-10">{t('subtitle')}</p>

      <div className="prose prose-stone max-w-none flex flex-col gap-6 text-[#3a5242] text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-[#1a2e1f] mb-2">{t('whatWeDoTitle')}</h2>
          <p>{t('whatWeDoBody')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1a2e1f] mb-2">{t('whyLocalTitle')}</h2>
          <p>{t('whyLocalBody1')}</p>
          <p className="mt-3">{t('whyLocalBody2')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1a2e1f] mb-2">{t('forArtisansTitle')}</h2>
          <p>{t('forArtisansBody')}</p>
          <p className="mt-3">
            <Link href="/sell/" className="text-[#2d7a4f] underline hover:text-[#1a5c36]">
              {t('startSellingLink')}
            </Link>
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1a2e1f] mb-2">{t('whereWeOperateTitle')}</h2>
          <p>
            {t.rich('whereWeOperateBody', {
              contactLink: (chunks) => (
                <Link href="/contact/" className="text-[#2d7a4f] underline hover:text-[#1a5c36]">
                  {chunks}
                </Link>
              ),
            })}
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1a2e1f] mb-2">{t('getInTouchTitle')}</h2>
          <p>
            {t.rich('getInTouchBody', {
              contactLink: (chunks) => (
                <Link href="/contact/" className="text-[#2d7a4f] underline hover:text-[#1a5c36]">
                  {chunks}
                </Link>
              ),
            })}
          </p>
        </section>
      </div>
    </main>
  );
}
